import { get, post, put, _delete } from './Tools';

const getAplicacionAguinaldo = async (anio_aguinaldo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/aplicacion/mostrar?anio=${anio_aguinaldo}`);
  return response;
};

const createMovimientoDiasHoras = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/generar_movimiento_diahora`, payload);
  return response;
};

const CancelarMovimientoDiasHoras = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}calculo_aguinaldo/eliminar_movimiento_diahora`, payload);
  return response;
};

const getEmpleadosActivos = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo/empleados/get/activos`);
  return response;
}

const getMovimientosDiasHoras = async (tipo_periodo, anio, num_periodo) => {
  const response = await get(`${process.env.REACT_APP_SERVER}movimiento_diashoras/${tipo_periodo}/${anio}/${num_periodo}`);
  return response;
};

export {
  getAplicacionAguinaldo,
  createMovimientoDiasHoras,
  CancelarMovimientoDiasHoras,
  getEmpleadosActivos,
  getMovimientosDiasHoras,
};
